import React, { Component } from 'react';
import Axios from 'axios';

/* Icons */
import EyeFilledIcon from '~/../symbols/eye-filled.svg';
import {Icon} from "../../common";

export default class ProductViewTrack extends Component {
    constructor(props) {
        super(props);

        this.state = {
            weeklyViews: 0,
            isLoading: true,
        };
    }

    componentDidMount = () => {
        const timeStamp = localStorage.getItem(`vehicle_${this.props.vehicleId}_view_timestamp`);
        const params = { timeStamp, vehicleId: this.props.vehicleId };
        this.fetchData(params);
    }

    fetchData = (params = {}) => {
        this.setState({ isLoading: true, });

        Axios.post(this.props.updateUrl, params).then((response) => {
            if (response.data) {
                const { weeklyViews, timestamp } = response.data;
                localStorage.setItem(`vehicle_${this.props.vehicleId}_view_timestamp`, timestamp);

                this.setState({
                    weeklyViews
                });
            }
        }).catch((error) => {
            throw new Error(error);
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    };

    render() {
        return (
            <div className="vehicle__view-track">
                <Icon className="mr-2" size={20} url={EyeFilledIcon.url} type="eye-filled" />
                {this.state.weeklyViews} x bekeken deze week
            </div>
        );
    }
}
